import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function EmptyDocumentsWidget() {
  const { t } = useTranslation(['common', 'dashboard']);

  return (
    <div className="t-p-5">
      <h2 className="Typography Typography--title u-weight-600">
        {t('dashboard:assets_title')}
      </h2>
      <p className="typo-epsilon t-text-beta-500 t-my-3">
        {t('dashboard:empty_assets')}
      </p>
      <div className="d-flex">
        <Link to="/plan/introduction" className="button-secondary">
          {t('common:go_to_estate_plan')}
        </Link>
      </div>
    </div>
  );
}

export default EmptyDocumentsWidget;
